import dayjs from 'dayjs';
import { TimeZone } from '../../time/timezone.js';
import { DataModelBuilder, SerializationContext, SerializedData } from '../../models/dto/dto.js';
import { MapUtils } from '../../utility/map-utils.js';
import { Component } from '../core/component.js';

export class LastActivityComponent extends Component {
  static readonly TYPE_ID: string = '16f0691483b743f7a154552d7ea71e7d';

  constructor(
    public readonly lastActivity: dayjs.Dayjs,
  ) {
    super();
  }

  get $removable(): boolean {
    return false;
  }

  get $typeId(): string {
    return LastActivityComponent.TYPE_ID;
  }

  static fromMap(context: SerializationContext, map: SerializedData): LastActivityComponent {
    return new LastActivityComponent(
        context.decodeDate(MapUtils.get<number>(map, 'lastActivity')),
    );
  }

  toMap(context: SerializationContext): SerializedData {
    return {
      'lastActivity': context.encodeDate(this.lastActivity),
    };
  }

  clone(): this {
    return new LastActivityComponent(
        TimeZone.cloneDate(this.lastActivity),
    ) as this;
  }

  isSame(other: this): boolean {
    if(other === this) {
      return true;
    }

    return other.lastActivity === this.lastActivity;
  }
}

export class LastActivityComponentBuilder extends DataModelBuilder<LastActivityComponent> {
  build(context: SerializationContext, map: SerializedData): LastActivityComponent {
    return LastActivityComponent.fromMap(context, map);
  }
}
